// extracted by mini-css-extract-plugin
export var countdownContainer = "styles-module--countdownContainer--3bVkK";
export var countdownTicker = "styles-module--countdownTicker--2aLq-";
export var revealElementStyle = "styles-module--revealElementStyle--2rK2G";
export var revealOpen = "styles-module--revealOpen--29sDj";